var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading,"icon":"","small":""},on:{"click":function($event){return _vm.$emit('expand', !_vm.expanded)}}},[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }